// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/mnt/docs/components/index.md?type=frontmatter';
import { demoIndex as dmi0 } from '/mnt/docs/components/index.md?type=demo-index';
import { frontmatter as fm1, toc as t1 } from '/mnt/docs/guide/quickstart.md?type=frontmatter';
import { demoIndex as dmi1 } from '/mnt/docs/guide/quickstart.md?type=demo-index';
import { frontmatter as fm2, toc as t2 } from '/mnt/docs/guide/design.md?type=frontmatter';
import { demoIndex as dmi2 } from '/mnt/docs/guide/design.md?type=demo-index';
import { frontmatter as fm3, toc as t3 } from '/mnt/docs/guide/color.md?type=frontmatter';
import { demoIndex as dmi3 } from '/mnt/docs/guide/color.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/mnt/docs/guide/index.md?type=frontmatter';
import { demoIndex as dmi4 } from '/mnt/docs/guide/index.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/mnt/docs/index.md?type=frontmatter';
import { demoIndex as dmi5 } from '/mnt/docs/index.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/mnt/src/components/Button/index.md?type=frontmatter';
import { demoIndex as dmi6 } from '/mnt/src/components/Button/index.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/mnt/src/components/Card/index.md?type=frontmatter';
import { demoIndex as dmi7 } from '/mnt/src/components/Card/index.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/mnt/src/components/Cascader/index.md?type=frontmatter';
import { demoIndex as dmi8 } from '/mnt/src/components/Cascader/index.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/mnt/src/components/Cell/index.md?type=frontmatter';
import { demoIndex as dmi9 } from '/mnt/src/components/Cell/index.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/mnt/src/components/Checkbox/index.md?type=frontmatter';
import { demoIndex as dmi10 } from '/mnt/src/components/Checkbox/index.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/mnt/src/components/CheckList/index.md?type=frontmatter';
import { demoIndex as dmi11 } from '/mnt/src/components/CheckList/index.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/mnt/src/components/Collapse/index.md?type=frontmatter';
import { demoIndex as dmi12 } from '/mnt/src/components/Collapse/index.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/mnt/src/components/ConfigProvider/index.md?type=frontmatter';
import { demoIndex as dmi13 } from '/mnt/src/components/ConfigProvider/index.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/mnt/src/components/DateRangePicker/index.md?type=frontmatter';
import { demoIndex as dmi14 } from '/mnt/src/components/DateRangePicker/index.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/mnt/src/components/DateTimePicker/index.md?type=frontmatter';
import { demoIndex as dmi15 } from '/mnt/src/components/DateTimePicker/index.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/mnt/src/components/Dialog/index.md?type=frontmatter';
import { demoIndex as dmi16 } from '/mnt/src/components/Dialog/index.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/mnt/src/components/Divider/index.md?type=frontmatter';
import { demoIndex as dmi17 } from '/mnt/src/components/Divider/index.md?type=demo-index';
import { frontmatter as fm18, toc as t18 } from '/mnt/src/components/DropDownMenu/index.md?type=frontmatter';
import { demoIndex as dmi18 } from '/mnt/src/components/DropDownMenu/index.md?type=demo-index';
import { frontmatter as fm19, toc as t19 } from '/mnt/src/components/Flex/index.md?type=frontmatter';
import { demoIndex as dmi19 } from '/mnt/src/components/Flex/index.md?type=demo-index';
import { frontmatter as fm20, toc as t20 } from '/mnt/src/components/Form/index.md?type=frontmatter';
import { demoIndex as dmi20 } from '/mnt/src/components/Form/index.md?type=demo-index';
import { frontmatter as fm21, toc as t21 } from '/mnt/src/components/Grid/index.md?type=frontmatter';
import { demoIndex as dmi21 } from '/mnt/src/components/Grid/index.md?type=demo-index';
import { frontmatter as fm22, toc as t22 } from '/mnt/src/components/GridView/index.md?type=frontmatter';
import { demoIndex as dmi22 } from '/mnt/src/components/GridView/index.md?type=demo-index';
import { frontmatter as fm23, toc as t23 } from '/mnt/src/components/Icon/index.md?type=frontmatter';
import { demoIndex as dmi23 } from '/mnt/src/components/Icon/index.md?type=demo-index';
import { frontmatter as fm24, toc as t24 } from '/mnt/src/components/Input/index.md?type=frontmatter';
import { demoIndex as dmi24 } from '/mnt/src/components/Input/index.md?type=demo-index';
import { frontmatter as fm25, toc as t25 } from '/mnt/src/components/NavBar/index.md?type=frontmatter';
import { demoIndex as dmi25 } from '/mnt/src/components/NavBar/index.md?type=demo-index';
import { frontmatter as fm26, toc as t26 } from '/mnt/src/components/Popup/index.md?type=frontmatter';
import { demoIndex as dmi26 } from '/mnt/src/components/Popup/index.md?type=demo-index';
import { frontmatter as fm27, toc as t27 } from '/mnt/src/components/Radio/index.md?type=frontmatter';
import { demoIndex as dmi27 } from '/mnt/src/components/Radio/index.md?type=demo-index';
import { frontmatter as fm28, toc as t28 } from '/mnt/src/components/Search/index.md?type=frontmatter';
import { demoIndex as dmi28 } from '/mnt/src/components/Search/index.md?type=demo-index';
import { frontmatter as fm29, toc as t29 } from '/mnt/src/components/Stepper/index.md?type=frontmatter';
import { demoIndex as dmi29 } from '/mnt/src/components/Stepper/index.md?type=demo-index';
import { frontmatter as fm30, toc as t30 } from '/mnt/src/components/Switch/index.md?type=frontmatter';
import { demoIndex as dmi30 } from '/mnt/src/components/Switch/index.md?type=demo-index';
import { frontmatter as fm31, toc as t31 } from '/mnt/src/components/Tabbar/index.md?type=frontmatter';
import { demoIndex as dmi31 } from '/mnt/src/components/Tabbar/index.md?type=demo-index';
import { frontmatter as fm32, toc as t32 } from '/mnt/src/components/Tabs/index.md?type=frontmatter';
import { demoIndex as dmi32 } from '/mnt/src/components/Tabs/index.md?type=demo-index';
import { frontmatter as fm33, toc as t33 } from '/mnt/src/components/Tag/index.md?type=frontmatter';
import { demoIndex as dmi33 } from '/mnt/src/components/Tag/index.md?type=demo-index';
import { frontmatter as fm34, toc as t34 } from '/mnt/src/components/Textarea/index.md?type=frontmatter';
import { demoIndex as dmi34 } from '/mnt/src/components/Textarea/index.md?type=demo-index';
import { frontmatter as fm35, toc as t35 } from '/mnt/src/components/Tip/index.md?type=frontmatter';
import { demoIndex as dmi35 } from '/mnt/src/components/Tip/index.md?type=demo-index';
import { frontmatter as fm36, toc as t36 } from '/mnt/src/components/Toast/index.md?type=frontmatter';
import { demoIndex as dmi36 } from '/mnt/src/components/Toast/index.md?type=demo-index';
import { frontmatter as fm37, toc as t37 } from '/mnt/src/components/Tooltip/index.md?type=frontmatter';
import { demoIndex as dmi37 } from '/mnt/src/components/Tooltip/index.md?type=demo-index';

export const filesMeta = {
  'docs/components/index': {
    frontmatter: fm0,
    toc: t0,
    demoIndex: dmi0,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/components/index.md?type=text'),
  },
  'docs/guide/quickstart': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/quickstart.md?type=text'),
  },
  'docs/guide/design': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/design.md?type=text'),
  },
  'docs/guide/color': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/color.md?type=text'),
  },
  'docs/guide/index': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/guide/index.md?type=text'),
  },
  'docs/index': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/index.md?type=text'),
  },
  'components/Button/index': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Button/index.md?type=text'),
  },
  'components/Card/index': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Card/index.md?type=text'),
  },
  'components/Cascader/index': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Cascader/index.md?type=text'),
  },
  'components/Cell/index': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Cell/index.md?type=text'),
  },
  'components/Checkbox/index': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Checkbox/index.md?type=text'),
  },
  'components/CheckList/index': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/CheckList/index.md?type=text'),
  },
  'components/Collapse/index': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Collapse/index.md?type=text'),
  },
  'components/ConfigProvider/index': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/ConfigProvider/index.md?type=text'),
  },
  'components/DateRangePicker/index': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/DateRangePicker/index.md?type=text'),
  },
  'components/DateTimePicker/index': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/DateTimePicker/index.md?type=text'),
  },
  'components/Dialog/index': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Dialog/index.md?type=text'),
  },
  'components/Divider/index': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Divider/index.md?type=text'),
  },
  'components/DropDownMenu/index': {
    frontmatter: fm18,
    toc: t18,
    demoIndex: dmi18,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/DropDownMenu/index.md?type=text'),
  },
  'components/Flex/index': {
    frontmatter: fm19,
    toc: t19,
    demoIndex: dmi19,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Flex/index.md?type=text'),
  },
  'components/Form/index': {
    frontmatter: fm20,
    toc: t20,
    demoIndex: dmi20,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Form/index.md?type=text'),
  },
  'components/Grid/index': {
    frontmatter: fm21,
    toc: t21,
    demoIndex: dmi21,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Grid/index.md?type=text'),
  },
  'components/GridView/index': {
    frontmatter: fm22,
    toc: t22,
    demoIndex: dmi22,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/GridView/index.md?type=text'),
  },
  'components/Icon/index': {
    frontmatter: fm23,
    toc: t23,
    demoIndex: dmi23,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Icon/index.md?type=text'),
  },
  'components/Input/index': {
    frontmatter: fm24,
    toc: t24,
    demoIndex: dmi24,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Input/index.md?type=text'),
  },
  'components/NavBar/index': {
    frontmatter: fm25,
    toc: t25,
    demoIndex: dmi25,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/NavBar/index.md?type=text'),
  },
  'components/Popup/index': {
    frontmatter: fm26,
    toc: t26,
    demoIndex: dmi26,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Popup/index.md?type=text'),
  },
  'components/Radio/index': {
    frontmatter: fm27,
    toc: t27,
    demoIndex: dmi27,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Radio/index.md?type=text'),
  },
  'components/Search/index': {
    frontmatter: fm28,
    toc: t28,
    demoIndex: dmi28,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Search/index.md?type=text'),
  },
  'components/Stepper/index': {
    frontmatter: fm29,
    toc: t29,
    demoIndex: dmi29,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Stepper/index.md?type=text'),
  },
  'components/Switch/index': {
    frontmatter: fm30,
    toc: t30,
    demoIndex: dmi30,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Switch/index.md?type=text'),
  },
  'components/Tabbar/index': {
    frontmatter: fm31,
    toc: t31,
    demoIndex: dmi31,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tabbar/index.md?type=text'),
  },
  'components/Tabs/index': {
    frontmatter: fm32,
    toc: t32,
    demoIndex: dmi32,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tabs/index.md?type=text'),
  },
  'components/Tag/index': {
    frontmatter: fm33,
    toc: t33,
    demoIndex: dmi33,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tag/index.md?type=text'),
  },
  'components/Textarea/index': {
    frontmatter: fm34,
    toc: t34,
    demoIndex: dmi34,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Textarea/index.md?type=text'),
  },
  'components/Tip/index': {
    frontmatter: fm35,
    toc: t35,
    demoIndex: dmi35,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tip/index.md?type=text'),
  },
  'components/Toast/index': {
    frontmatter: fm36,
    toc: t36,
    demoIndex: dmi36,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Toast/index.md?type=text'),
  },
  'components/Tooltip/index': {
    frontmatter: fm37,
    toc: t37,
    demoIndex: dmi37,
    textGetter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tooltip/index.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
